<template>
  <div class="header">
    <div
      class="headerImg"
      @click="
        () => {
          drawerVisible = true
        }
      "
    >
      <span>{{ String($store.state.userInfo.name)[0] }}</span>
    </div>
    <div class="headerFont">
      <div class="headerFontName">{{ $store.state.userInfo.name }}</div>
      <div class="headerFontRole">{{ $store.state.userInfo.role }}</div>
    </div>

    <el-drawer size="70%" :show-close="false" direction="ltr" :visible.sync="drawerVisible">
      <template #title>
        <div class="drawerTitle">{{ $store.state.userInfo.name }}</div>
      </template>

      <div class="personal-popup__infolist">
        <div
          class="personal-popup__list-item"
          v-for="(item, index) of popupList"
          :key="index"
          @click="handleClickItem(item)"
        >
          <el-row :gutter="0">
            <!-- icon -->
            <el-col :span="4">
              <div class="col-item">
                <!-- <image :src="item.imgSrc"></image> -->
                <i :style="'color:' + item.color" :class="item.icon" />
              </div>
            </el-col>

            <!-- label -->
            <el-col :span="8">
              <div class="col-item">
                {{ item.label }}
              </div>
            </el-col>

            <!-- value -->
            <el-col :span="12">
              <div class="col-item col-value">
                {{ item.value ? item.value : $store.state.userInfo[item.key] }}
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="personal-popup__bottom" @click="handleLogout">
        <div class="logout-btn">退出登录</div>
      </div>

      <!-- 个人信息弹窗 -->
      <ChangePwd ref="ChangePwdRef" />
    </el-drawer>
  </div>
</template>
<script>
import ChangePwd from '@/components/app/changePwd.vue'

export default {
  components: {
    ChangePwd
  },
  data() {
    return {
      // 是否显示用户
      drawerVisible: false,
      // 菜单列表
      popupList: [
        {
          icon: 'el-icon-user',
          color: '#77bd88',
          label: '角色',
          key: 'role'
          // value: '领导'
        },
        {
          icon: 'el-icon-lock',
          color: '#409eff',
          label: '密码修改',
          value: '>'
        }
      ]
    }
  },
  methods: {
    // 点击行item时
    handleClickItem(item) {
      if (item.label === '密码修改') {
        this.$refs.ChangePwdRef.formVisible = true
      }
    },
    // 点击退出登录
    handleLogout() {
      this.setStorage()

      this.$router.push('/Login')
    },
    // 设置缓存 [是否记住用户名和密码 | 用户名 | 密码]
    setStorage() {
      localStorage.removeItem('userName')
      localStorage.removeItem('password')
      // 将是否记住密码存为缓存
      localStorage.setItem('isRemember', 'false')
    }
  }
}
</script>
<style lang="less" scoped>
.header {
  display: flex;
  flex: none;
  padding: 10px 0;
  .headerImg {
    width: 50px;
    height: 50px;
    border-radius: 50px;
    background-color: #6c9eff;
    color: #fff;

    display: flex;
    justify-content: center;
    align-items: center;

    font-size: 20px;
  }
  .headerFont {
    margin-left: 10px;
    .headerFontName {
      font-weight: bold;
      font-size: 16px;
      height: 30px;
      // box-sizing: border-box;
      // padding-top: 5px;
      display: flex;
      align-items: center;
    }
    .headerFontRole {
      color: #aaaaaa;
      font-size: 12px;
      height: 15px;

      display: flex;
      align-items: center;
    }
  }
}
.drawerTitle {
  font-size: 24px;
  color: #000;
}
.personal-popup__infolist {
  box-sizing: border-box;
  padding: 0 20px;

  margin-top: 5px;

  .personal-popup__list-item {
    width: 100%;
    height: 40px;
    margin-bottom: 10px;
  }
}
.personal-popup__bottom {
  box-sizing: border-box;
  padding: 0 20px;
}
// 退出登录按钮
.logout-btn {
  margin-bottom: 10px;

  &:active {
    background-color: #f2f3f5;
  }

  // @include flex-center();
  display: flex;
  justify-content: center;
  align-items: center;

  // @include long-btn(#fff, $uni-color-error);
  margin-top: 30px;
  width: 100%;
  height: 40px;
  border-radius: 30px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.15);
  // box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, $shadowOpacity);
  color: #ff6f6f;
  background-color: #fff;
  font-size: 18px;
}

.col-item {
  height: 30px;
  display: flex;
  align-items: center;

  font-size: 15px;

  i {
    font-size: 26px;
    color: #81c08f;
  }
  // > image {
  //   height: 44rpx;
  //   width: 44rpx;
  // }
}
.col-value {
  justify-content: flex-end;
  color: #aaaaaa;
}
</style>
